export default __webpack_public_path__ + "static/media/Cloudxier_graphics-each-expertise-01.376912c3.png";